import React from 'react';
import { LoadingSC } from './Loading.style';
import { ReactComponent as LoadingImage } from '../../../assets/svg/loading.svg';

const Loading = (props) => {
  const { gap, className, background } = props;
  return (
    <LoadingSC gap={gap} className={className} background={background}>
      <LoadingImage className="loading-img" />
    </LoadingSC>
  );
};
export default Loading;
